export default __webpack_public_path__ + "static/media/image18.121338a2.png";